var App = App || {};

App.SubPages = (function ($) {
    'use strict';

    var LgBp = 992,
        promoCard,
        promoCardHeight,
        winTouchPoint;

    function init() {
        $(document).ready(function () {
            winTouchPoint = $(window).outerWidth();
            repositionPromos();
        });

        $(window).resize(function () {
            if ($(window).outerWidth() >= LgBp && winTouchPoint < LgBp) {
                winTouchPoint = $(window).outerWidth();
                repositionPromos();
            } else if ($(window).outerWidth() < LgBp && winTouchPoint >= LgBp) {
                winTouchPoint = $(window).outerWidth();
                repositionPromos();
            }
        });
        
    }

    function repositionPromos() {
        $(".blog-posts-lists").each(function () {
            var promoWrapper = $(this).find(".promo-wrapper");

            if (promoWrapper.length) {
                var promoWrapperHeight = promoWrapper.outerHeight();
                promoWrapper.css("bottom", -(promoWrapperHeight / 2) + "px");


                if ($(window).outerWidth() < LgBp) {
                    $(this).css("padding-bottom", (promoWrapperHeight / 2) + 30 + "px").css("margin-bottom", "calc(3rem + " + (promoWrapperHeight / 2) + "px)");
                }
                else {
                    $(this).css("padding-bottom", (promoWrapperHeight / 2) + 90 + "px").css("margin-bottom", "calc(9rem + " + (promoWrapperHeight / 2) + "px)");
                }
            }
        });

        $(".component-group").each(function () {
            var promoBand = $(this).find(".component-pagepromo.offset"),
                promoCard = promoBand.find(".pagepromo-inner > a");

            if (promoCard.length && promoBand.parent().hasClass("component-group") && !promoBand.next().length) {
                promoCardHeight = promoCard.outerHeight();

                if ($(window).outerWidth() < LgBp) {
                    promoBand.css("margin-bottom", "calc(-1rem - (" + promoCardHeight + "px / 2))");
                    promoBand.parent().css("margin-bottom", "calc(2rem + " + (promoCardHeight / 2) + "px)");
                }
                else {
                    promoBand.css("margin-bottom", "calc(-2.5rem - (" + promoCardHeight + "px / 2))");
                    promoBand.parent().css("margin-bottom", "calc(5rem + " + (promoCardHeight / 2) + "px)");
                }
            }
        });
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.SubPages.init();
});